/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { addDays, isFuture, format } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import Chip from '@mui/material/Chip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendar,
} from '@fortawesome/free-solid-svg-icons';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './customize_date_range_picker.css'; // customize css

import classes from './index.module.css';

export default ({
  onChange,
}) => {
  const yesterday = addDays(new Date(), -1);
  const [showCalendar, setShowCalendar] = useState(false);
  const [date, setDate] = useState({
    range1: {
      startDate: yesterday,
      endDate: yesterday,
      key: 'range1',
    },
    range2: {
      startDate: yesterday,
      endDate: yesterday,
      key: 'range2',
    },
    range3: {
      startDate: yesterday,
      endDate: yesterday,
      key: 'range3',
    },
    range4: {
      startDate: yesterday,
      endDate: yesterday,
      key: 'range4',
    },
    range5: {
      startDate: yesterday,
      endDate: yesterday,
      key: 'range5',
    },
  });
  const onRangeChange = (dateRanges) => {
    const ranges = Object.values(dateRanges);
    console.log(ranges);
    if (typeof onChange === 'function') {
      onChange(ranges);
    }
  };

  const handleDelete = (key) => {
    const nextDateRange = {
      ...date,
      [key]: {
        startDate: yesterday,
        endDate: yesterday,
        key,
      },
    };
    onRangeChange(nextDateRange);
    setDate(nextDateRange);
  };

  React.useEffect(() => {
    document.addEventListener('click', () => setShowCalendar(false));
  }, []);

  return (
    <div
      className={classes.container}
      onClick={(ev) => {
        ev.nativeEvent.stopImmediatePropagation();
      }}
    >
      <div
        className={classes.date_range}
      >
        <div className={classes.date_rage_chips}>
          {
            Object.values(date).map((item) => {
              const { key, startDate, endDate } = item;
              if (isFuture(startDate) && isFuture(endDate)) {
                return (
                  <Chip
                    key={key}
                    size="small"
                    label={`${format(startDate, 'MMM dd')}-${format(endDate, 'MMM dd')}`}
                    variant="outlined"
                    onDelete={() => {
                      handleDelete(key);
                    }}
                  />
                );
              }
              return null;
            })
          }
        </div>
        <FontAwesomeIcon
          onClick={(ev) => {
            setShowCalendar((val) => !val);
          }}
          className={classes.calendar_icon}
          icon={faCalendar}
        />
      </div>
      {showCalendar ? (
        <DateRangePicker
          months={2}
          rangeColors={['#645AFF', '#645AFF', '#645AFF', '#645AFF', '#645AFF']}
          minDate={addDays(new Date(), 0)}
          maxDate={addDays(new Date(), 365)}
          direction="horizontal"
          onChange={(item, ...rest) => {
            const nextDateRange = { ...date, ...item };
            onRangeChange(nextDateRange);
            setDate(nextDateRange);
          }}
          ranges={[date.range1, date.range2, date.range3, date.range4, date.range5]}
        />
      ) : null}
    </div>
  );
};
